import {
  GPSTRACKING_FETCHING,
  GPSTRACKING_SUCCESS,
  GPSTRACKING_FAILED,
} from "../actions/types";

const initialState = {
  loaded: false,
  coordinates: { lat: "", lng: "" },
  error: null,
  loading: false,
  status: "กำลังเชื่อมต่อGPS",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GPSTRACKING_FETCHING:
      return { ...state, loading: true, status: "กำลังเชื่อมต่อGPS" };

    case GPSTRACKING_SUCCESS:
      return {
        ...state,
        loaded: true,
        coordinates: action.payload,
        error: null,
        loading: false,
        status: "เชื่อมต่อGPSสำเร็จ",
      };

    case GPSTRACKING_FAILED:
      return {
        ...state,
        loaded: true,
        error: action.payload,
        loading: false,
        status: "เชื่อมต่อGPSไม่สำเร็จ",
      };

    default:
      return state;
  }
}
